import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./feature-search.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./feature-search.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild, ViewChildren, } from "@angular/core";
import { FeatureSearchConstants } from "./feature-search.constants";
import { FeatureSearchService } from "./shared/services/feature-search.service";
import { catchError, map, of } from "rxjs";
import { SharedConstants } from "../../shared/constants/shared.constants";
import { MapServiceService } from "../../core/settings/shared/map-service.service";
import { AppControllerService } from "../../app-controller.service";
import { RequestStatusService } from "../../shared/services/request-status/request-status.service";
import { SaveSearchService } from "../../shared/services/save-search/save-search.service";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CRUDOperation } from "../../shared/models/crud-operation-enum.model";
import { AppConfig } from "../../app.config";
import { AlertType } from "../../shared/models/alert";
import { UserInformationService } from "../../shared/services/user/user-information.service";
import { OrganisationSettingsService } from "../../core/organisations/organisation-settings.service";
let FeatureSearchComponent = class FeatureSearchComponent {
    featureSearchService;
    mapService;
    appControllerService;
    changeDetectorRef;
    requestStatusService;
    saveSearchService;
    userInformationService;
    organisationSettingsService;
    acc;
    controls;
    pageHeading = FeatureSearchConstants.PAGE_HEADING;
    attributeToTableColumn;
    selectedProperty;
    dataSource;
    isMapLoaded = false;
    loadMap = false;
    parentComponent = FeatureSearchConstants.PARENT_COMPONENT_NAME;
    disableAccordian = false;
    searchForm;
    filterForm;
    searchOptionFormControl = FeatureSearchConstants.SEARCH_OPTION_CONTROL;
    selectColumnOptionFormControl = FeatureSearchConstants.SELECT_COLUMN_OPTION_CONTROL;
    selectFilterOptionFormControl = FeatureSearchConstants.SELECT_FILTER_OPTION_CONTROL;
    descriptionLabel1 = FeatureSearchConstants.DESCRIPTION_LABEL1;
    descriptionLabel2 = FeatureSearchConstants.DESCRIPTION_LABEL2;
    descriptionLabel3 = FeatureSearchConstants.DESCRIPTION_LABEL3;
    searchOptionFormControlLabel = FeatureSearchConstants.SEARCH_OPTION_CONTROL_LABEL;
    queryBuilderHeadingLabel = FeatureSearchConstants.QUERY_BUILDER_HEADING_LABEL;
    mapHeadingLabel = FeatureSearchConstants.MAP_HEADING_LABEL;
    searchResultsHeadingLabel = FeatureSearchConstants.SEARCH_RESULTS_HEADING_LABEL;
    selectAllLabel = FeatureSearchConstants.SELECT_ALL_LABEL;
    resetLabel = FeatureSearchConstants.RESET_LABEL;
    searchLabel = FeatureSearchConstants.SEARCH_LABEL;
    excludedFields = [];
    zones = [];
    currentModule;
    moduleTemplates;
    mapLocationAsObservableSubscription;
    getMapServicesSubscription;
    getModuleTemplatesSubscription;
    accordianToggleSubscription;
    searches = [];
    showWhereSection = false;
    showHideColumns = false;
    showHideFilters = false;
    showFieldSelector = false;
    selectedSearchConfiguration = [];
    columns = [];
    filters = [];
    selectedFilters = [];
    lookups = [];
    showHideColumnsLabel = FeatureSearchConstants.SHOW_HIDE_COLUMNS_LABEL;
    showHideFiltersLabel = FeatureSearchConstants.SHOW_HIDE_FILTERS_LABEL;
    selectColumnOptionFormControlLabel = FeatureSearchConstants.SELECT_COLUMN_OPTION_CONTROL_LABEL;
    selectFilterOptionFormControlLabel = FeatureSearchConstants.SELECT_FILTER_OPTION_CONTROL_LABEL;
    filterNameText = FeatureSearchConstants.FILTER_NAME_TEXT;
    filterOperatorText = FeatureSearchConstants.FILTER_OPERATOR_TEXT;
    valueOperatorText = FeatureSearchConstants.VALUE_OPERATOR_TEXT;
    lookupValuePlaceholder = FeatureSearchConstants.LOOKUP_VALUE_PLACEHOLDER;
    constructor(featureSearchService, mapService, appControllerService, changeDetectorRef, requestStatusService, saveSearchService, userInformationService, organisationSettingsService) {
        this.featureSearchService = featureSearchService;
        this.mapService = mapService;
        this.appControllerService = appControllerService;
        this.changeDetectorRef = changeDetectorRef;
        this.requestStatusService = requestStatusService;
        this.saveSearchService = saveSearchService;
        this.userInformationService = userInformationService;
        this.organisationSettingsService = organisationSettingsService;
        this.excludedFields = AppConfig.settings.searchOptions.excludeFieldList;
    }
    ngOnInit() {
        this.initForms();
        this.requestStatusService.showBusySpinner("InitialPageLoad");
        this.getModuleTemplatesSubscription = this.organisationSettingsService.getModuleTemplates().subscribe({
            next: data => {
                this.moduleTemplates = data;
            }, error: err => {
                this.appControllerService.handleServerErrorMessage(FeatureSearchConstants.COMPONENT_NAME, err, CRUDOperation.Get);
            }
        });
        this.currentModule = this.userInformationService.getModuleInformation(+this.appControllerService.selectedModuleID);
        this.getSearches();
        this.dataSource = of([]);
        this.attributeToTableColumn = new Map();
    }
    initForms() {
        this.searchForm = new FormGroup({
            searchOptionFromControl: new FormControl(null, [Validators.required]),
            selectColumnOptionFormControl: new FormControl(null, [Validators.required]),
            selectFilterOptionFormControl: new FormControl(null, [Validators.required])
        });
        this.filterForm = new FormGroup({});
    }
    ngAfterViewInit() {
        this.controls.changes.subscribe(() => {
            if (this.controls.length) {
                console.log("map stuff here", this.controls.first);
            }
        });
        this.listenForSelectedPropertyChange();
        this.listenForAccordianToggle();
        // Dirty Fix for Map Loading - (my own version of lazy loading)
        setTimeout(() => {
            this.loadMap = true;
            this.changeDetectorRef.detectChanges();
            setTimeout(() => {
                const divMapForProperties = document.getElementById("divMapForProperties");
                divMapForProperties.setAttribute("style", "display:block;");
                this.changeDetectorRef.detectChanges();
                this.requestStatusService.removeBusySpinner("InitialPageLoad");
            }, 300);
        }, 300);
    }
    ngOnDestroy() {
        this.dataSource = null;
        this.saveSearchService.clearSavedSearchResults();
        this.changeDetectorRef.detectChanges();
    }
    getSearches() {
        const tableItems = [];
        this.searches = [];
        this.getMapServicesSubscription = this.mapService.getMaps(+this.appControllerService.selectedModuleID, tableItems).subscribe({
            next: (response) => {
                if (response.length === 0) {
                    this.acc.collapseAll();
                    this.appControllerService.showMessage(FeatureSearchConstants.NO_SEARCHES_MESSAGE, AlertType.Warning);
                    this.disableAccordian = true;
                    return;
                }
                response.forEach(element => {
                    if (element.enableSearch === true) {
                        this.searches.push({
                            name: element.name,
                            alias: element.name,
                            displayFields: [],
                            filters: [],
                            id: element.id,
                            disabled: false,
                            locked: false,
                            default: false,
                            url: element.url
                        });
                    }
                });
                this.requestStatusService.removeBusySpinner("InitialPageLoad");
                if (this.searches.length === 0) {
                    this.acc.collapseAll();
                    this.appControllerService.showMessage(FeatureSearchConstants.NO_SEARCHES_MESSAGE, AlertType.Warning);
                    this.disableAccordian = true;
                    return;
                }
                else if (this.searches.length === 1) {
                    this.disableAccordian = false;
                    this.searchForm.get(this.searchOptionFormControl).setValue(this.searches[0].name);
                    this.updateFrom();
                }
                else if (this.searches.length > 1) {
                    this.disableAccordian = false;
                    this.searchForm.get(this.searchOptionFormControl).setValue(this.searches[0].name);
                    this.updateFrom();
                }
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(FeatureSearchConstants.COMPONENT_NAME, error, CRUDOperation.Get);
            }
        });
    }
    updateFrom() {
        this.showWhereSection = true;
        this.showFieldSelector = true;
        this.columns = [];
        this.filters = [];
        this.selectedFilters = [];
        this.filterForm = new FormGroup({});
        this.searchForm.get(this.selectColumnOptionFormControl).setValue(null);
        const selectedValue = this.searchForm.get(this.searchOptionFormControl).value;
        this.selectedSearchConfiguration = this.searches.find(x => x.name === selectedValue);
        this.getFeatureLayerFields();
        this.changeDetectorRef.detectChanges();
    }
    bindDisplayColumns() {
        this.columns = this.selectedSearchConfiguration.displayFields.sort((a, b) => (a.order < b.order ? -1 : 1));
        if (this.columns.length === 0) {
            this.searchForm.get(this.selectColumnOptionFormControl).disable();
            this.searchForm.get(this.selectColumnOptionFormControl).setValue("");
        }
        else {
            this.searchForm.get(this.selectColumnOptionFormControl).enable();
            const selectionMap = this.selectedSearchConfiguration.displayFields.map(x => x.name);
            this.searchForm.get(this.selectColumnOptionFormControl).setValue(selectionMap);
        }
    }
    bindFilterColumns() {
        this.filters = this.selectedSearchConfiguration.filters.sort((a, b) => (a.name < b.name ? -1 : 1));
        if (this.filters.length === 0) {
            this.searchForm.get(this.selectFilterOptionFormControl).disable();
            this.searchForm.get(this.selectFilterOptionFormControl).setValue("");
        }
        else {
            this.searchForm.get(this.selectFilterOptionFormControl).enable();
        }
    }
    bindFilters() {
        this.selectedFilters.sort((a, b) => (a.alias < b.alias ? -1 : 1));
        this.selectedFilters.forEach(item => {
            item.filterNameControl = `${item.name}_NAME_CONTROL`;
            item.filterTypeControl = `${item.name}_TYPE_CONTROL`;
            item.filterOperatorControl = `${item.name}_OPERATOR_CONTROL`;
            this.filterForm.addControl(item.filterNameControl, new FormControl(item.name));
            this.filterForm.addControl(item.filterTypeControl, new FormControl(item.type));
            this.filterForm.addControl(item.filterOperatorControl, new FormControl(item.operator));
            this.filterForm.get(item.filterNameControl).disable();
            this.filterForm.get(item.filterTypeControl).disable();
            this.filterForm.get(item.filterOperatorControl).disable();
            item.filterValueControl = `${item.name}_VALUE_CONTROL`;
            item.value = null;
            this.filterForm.addControl(item.filterValueControl, new FormControl(item.value));
            this.filters.push(item);
        });
        this.changeDetectorRef.detectChanges();
    }
    onShowHideColumns() {
        this.showHideColumns = !this.showHideColumns;
    }
    onShowHideFilters() {
        this.showHideFilters = !this.showHideFilters;
    }
    updateSelect() {
        const valueFromControl = this.searchForm.get(this.selectColumnOptionFormControl).value;
        const selectAll = valueFromControl.find(x => x.toLowerCase() === "select all");
        if (selectAll !== null && selectAll !== undefined && selectAll.length > 0) {
            const selectionMap = this.selectedSearchConfiguration.displayFields.map(x => x.name);
            this.searchForm.get(this.selectColumnOptionFormControl).setValue(selectionMap);
        }
        this.changeDetectorRef.detectChanges();
    }
    updateFilterSelect() {
        this.selectedFilters = [];
        const valueFromControl = this.searchForm.get(this.selectFilterOptionFormControl).value;
        valueFromControl.forEach(item => {
            const filter = this.filters.find(x => x.name === item);
            if (filter !== null && filter !== undefined) {
                this.selectedFilters.push(filter);
            }
        });
        this.bindFilters();
        this.changeDetectorRef.detectChanges();
    }
    onBtnResetClicked() {
        this.attributeToTableColumn = new Map();
        this.columns = [];
        this.filters = [];
        this.selectedFilters = [];
        this.searchForm.get(this.selectColumnOptionFormControl).disable();
        this.searchForm.get(this.selectColumnOptionFormControl).setValue("");
        this.filterForm = new FormGroup({});
        this.showWhereSection = false;
        this.showFieldSelector = false;
        this.showHideColumns = false;
        this.searchForm.reset();
        this.filterForm.reset();
        this.selectedSearchConfiguration = [];
        this.dataSource = null;
        if (this.isMapLoaded) {
            this.controls.first.removeGraphicsFromMap(FeatureSearchConstants.SELECTED_PROPERTY_GRAPHICS_LAYER);
        }
        this.getSearches();
    }
    onBtnSearchClicked() {
        const requestObj = {};
        requestObj.moduleId = this.appControllerService.selectedModuleID;
        requestObj.propertySearchesMeta = [];
        requestObj.fieldsData = [];
        requestObj.propertySearchesMeta.push({
            name: this.selectedSearchConfiguration.name,
            alias: this.selectedSearchConfiguration.alias,
            type: this.selectedSearchConfiguration.type,
            key: "sgcode"
        });
        if (requestObj.propertySearchesMeta === null || requestObj.propertySearchesMeta === undefined || requestObj.propertySearchesMeta.length === 0) {
            this.appControllerService.showMessage(FeatureSearchConstants.NO_SEARCH_SELECTED, AlertType.Warning);
            return;
        }
        const selectedFields = this.searchForm.get(this.selectColumnOptionFormControl).value;
        if (selectedFields === null || selectedFields === undefined || selectedFields.length === 0) {
            this.appControllerService.showMessage(FeatureSearchConstants.MINIMUM_SELECTION_MESSAGE_FIELDS, AlertType.Warning);
            return;
        }
        selectedFields.forEach(item => {
            // filters
            let displayField = this.columns.find(x => x.name === item);
            let filter = this.selectedFilters.find(x => x.name === item);
            if (filter !== null && filter !== undefined) {
                filter.value = this.filterForm.get(filter.filterValueControl).value;
                if (filter.value !== null && filter.value !== undefined) {
                    filter.value = filter.value.toString();
                    requestObj.fieldsData.push({
                        name: filter.name,
                        alias: filter.alias,
                        controlType: filter.type,
                        fieldType: filter.type,
                        value: filter.value
                    });
                }
                else {
                    requestObj.fieldsData.push({
                        name: filter.name,
                        alias: filter.alias,
                        controlType: filter.type,
                        fieldType: filter.type,
                        value: null
                    });
                }
            }
            else {
                requestObj.fieldsData.push({
                    name: displayField.name,
                    alias: displayField.alias,
                    controlType: displayField.type,
                    fieldType: displayField.type,
                    value: null
                });
            }
        });
        const checkForFilter = requestObj.fieldsData.find(x => x.value !== null);
        if (checkForFilter === null || checkForFilter === undefined) {
            this.appControllerService.showMessage(FeatureSearchConstants.MINIMUM_SELECTION_MESSAGE_FILTER, AlertType.Warning);
            return;
        }
        this.mapColumns(requestObj.fieldsData);
        this.dataSource = this.featureSearchService.doPropertySearch(requestObj)
            .pipe(map(data => {
            const values = [];
            if (data !== null && data !== undefined && data.value.length !== 0) {
                const selectedSearch = this.selectedSearchConfiguration;
                data.value.forEach(item => {
                    let record = {
                        id: item.id,
                        sgcode: item.sgCode
                    };
                    if (item.extendedProperties !== null) {
                        for (const [key, value] of Object.entries(item.extendedProperties)) {
                            record[key] = value;
                        }
                    }
                    values.push(record);
                });
                const currentModuleTemplate = this.moduleTemplates.find(x => x.id === this.currentModule.moduleTemplateId);
                const canCreate = FeatureSearchConstants.CREATE_APPLICATION_LIST.modules.find(x => x.toLocaleLowerCase() === currentModuleTemplate.systemPrefix.toLocaleLowerCase());
                let showCreateApplicationLink = false;
                if (canCreate !== null && canCreate !== undefined) {
                    showCreateApplicationLink = true;
                }
                this.featureSearchService.addMapLocatorLinks(values, selectedSearch.url, showCreateApplicationLink);
                return values;
            }
            else {
                this.appControllerService.showMessage("No results found", AlertType.Warning);
            }
        }), catchError(error => {
            throw (error);
        }));
        this.acc.collapseAll();
        this.acc.toggle("resultGrid");
    }
    mapColumns(fields) {
        this.attributeToTableColumn = new Map();
        fields.forEach(item => {
            this.attributeToTableColumn.set(item.alias, item.name);
        });
        this.changeDetectorRef.detectChanges();
    }
    /// NEW QUERY BUILDER STUFF
    getFeatureLayerFields() {
        this.selectedSearchConfiguration.fields = [];
        const params = {
            moduleId: +this.appControllerService.selectedModuleID,
            layerName: this.selectedSearchConfiguration.name
        };
        this.featureSearchService.getSelectedSearchLayerFields(params).subscribe({
            next: (data) => {
                if (data) {
                    data.forEach(item => {
                        const isExludedField = this.excludedFields.find(x => item.name.toLowerCase().includes(x.toLowerCase())) ?? false;
                        if (isExludedField === false) {
                            const newField = {
                                name: item.name,
                                alias: item.alias,
                                order: item.order,
                                type: item.type,
                                operator: "contains"
                            };
                            this.selectedSearchConfiguration.displayFields.push(newField);
                            const newFilter = {
                                name: item.name,
                                alias: item.alias,
                                order: item.order,
                                type: item.type,
                                operator: "contains"
                            };
                            this.selectedSearchConfiguration.filters.push(newFilter);
                        }
                    });
                    this.bindDisplayColumns();
                    this.bindFilterColumns();
                }
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(FeatureSearchConstants.COMPONENT_NAME, error, CRUDOperation.Get);
            }
        });
    }
    mapLoaded() {
        this.isMapLoaded = true;
    }
    exportTableClicked($event) {
        //this.selectedPropertySubject.next($event);
    }
    listenForSelectedPropertyChange() {
        this.mapLocationAsObservableSubscription = this.featureSearchService.mapLocationAsObservable.subscribe((selectedPropertyId) => {
            if (selectedPropertyId && selectedPropertyId !== "") {
                this.viewSelectedPropertyOnMap(selectedPropertyId);
            }
        });
    }
    listenForAccordianToggle() {
        this.accordianToggleSubscription = this.acc.show.subscribe({
            next: data => {
                if (data === "query") {
                    this.acc.collapse("map");
                    this.acc.collapse("resultGrid");
                    return;
                }
                if (data === "map") {
                    const divMapForProperties = document.getElementById("divMapForProperties");
                    divMapForProperties.setAttribute("style", "display:block;");
                    this.changeDetectorRef.detectChanges();
                    this.acc.collapse("query");
                    const isResultGridShown = this.acc.isExpanded("resultGrid");
                    const divResultGrid = document.getElementById("divResultGrid");
                    if (isResultGridShown === true) {
                        divResultGrid.setAttribute("style", "max-height:30vh; overflow-y: scroll;");
                    }
                    this.changeDetectorRef.detectChanges();
                    return;
                }
                if (data === "resultGrid") {
                    this.acc.collapse("query");
                    return;
                }
            }, error: error => {
                console.log("accordion toggle error: " + error);
            }
        });
        this.accordianToggleSubscription = this.acc.hide.subscribe({
            next: data => {
                if (data === "map") {
                    const divResultGrid = document.getElementById("divResultGrid");
                    divResultGrid.setAttribute("style", "max-height:70vh; overflow-y: scroll;");
                    this.changeDetectorRef.detectChanges();
                    return;
                }
            }, error: error => {
                console.log("accordion toggle error: " + error);
            }
        });
    }
    viewSelectedPropertyOnMap(propertyId) {
        const isMapShown = this.acc.isExpanded("map");
        if (!isMapShown) {
            this.acc.expand("map");
        }
        const selectedSearch = this.selectedSearchConfiguration;
        this.requestStatusService.showBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        this.featureSearchService.doSearch(selectedSearch.url, propertyId, "objectId", true, true).then((result) => {
            if (result.length > 0) {
                this.setMapRoute(result);
            }
            this.requestStatusService.removeBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        });
    }
    setMapRoute(properties) {
        // Dirty Fix for Map Loading
        setTimeout(() => {
            if (this.isMapLoaded) {
                this.controls.first.removeGraphicsFromMap(FeatureSearchConstants.SELECTED_PROPERTY_GRAPHICS_LAYER);
                const geometries = [];
                properties.forEach((property) => {
                    geometries.push(property.geometry);
                });
                this.controls.first.addGeometriesOnMap(geometries, FeatureSearchConstants.SELECTED_PROPERTY_GRAPHICS_LAYER);
                this.changeDetectorRef.detectChanges();
            }
        }, 300);
    }
    static ctorParameters = () => [
        { type: FeatureSearchService },
        { type: MapServiceService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RequestStatusService },
        { type: SaveSearchService },
        { type: UserInformationService },
        { type: OrganisationSettingsService }
    ];
    static propDecorators = {
        acc: [{ type: ViewChild, args: ["accordion",] }],
        controls: [{ type: ViewChildren, args: ["esripropertiesmap",] }]
    };
};
FeatureSearchComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-feature-search",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], FeatureSearchComponent);
export { FeatureSearchComponent };
